// extracted by mini-css-extract-plugin
export var megalist = "index-module--megalist--39b91";
export var megamenu = "index-module--megamenu--a62c0";
export var navdesktop = "index-module--navdesktop--21446";
export var overflowLock = "index-module--overflow-lock--48cb7";